var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from '@angular/common/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackAuth } from '../core/auth.service';
import { ErrorHandler } from '../core/error.service';
/**
 * Api services for the `PayeeServiceMID` model.
 */
var PayeeServiceMIDApi = /** @class */ (function (_super) {
    __extends(PayeeServiceMIDApi, _super);
    function PayeeServiceMIDApi(http, models, auth, errorHandler) {
        var _this = _super.call(this, http, models, auth, errorHandler) || this;
        _this.http = http;
        _this.models = models;
        _this.auth = auth;
        _this.errorHandler = errorHandler;
        return _this;
    }
    /**
     * The name of the model represented by this $resource,
     * i.e. `PayeeServiceMID`.
     */
    PayeeServiceMIDApi.prototype.getModelName = function () {
        return "PayeeServiceMID";
    };
    return PayeeServiceMIDApi;
}(BaseLoopBackApi));
export { PayeeServiceMIDApi };
